export const AIRLINES = [
  "IndiGo", "Air India", "Air India Express", "SpiceJet", "Vistara", "Akasa Air",
  "Emirates", "Etihad Airways", "Qatar Airways", "Saudia", "flynas", "flyadeal",
  "Gulf Air", "Oman Air", "Kuwait Airways", "Jazeera Airways", "flydubai", "Air Arabia",
  "SalamAir", "Biman Bangladesh Airlines", "SriLankan Airlines", "Nepal Airlines",
  "Malaysia Airlines", "AirAsia", "Singapore Airlines", "Turkish Airlines", "EgyptAir",
  "Royal Jordanian", "British Airways", "Lufthansa", "American Airlines", "United Airlines",
  "Cathay Pacific", "Thai Airways", "Pakistan International Airlines", "Other",
].map((a) => ({ value: a, label: a }));
